import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "responsive"];
import styled, { css } from 'styled-components';
import { GYPSUM, OLAF, OBSIDIAN } from 'HubStyleTokens/colors';
import { GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_EXTRA_LARGE } from 'HubStyleTokens/sizes';
import { LAYOUT_PADDING_X } from 'HubStyleTokens/sizes';
import { MAIN_SECTION_PADDING_Y, MAIN_SECTION_PADDING_X } from '../constants/';
import { jsx as _jsx } from "react/jsx-runtime";
const getBackgroundColor = color => {
  switch (color) {
    case 'light':
      return GYPSUM;
    case 'dark':
      return OBSIDIAN;
    case 'default':
      return OLAF;
    default:
      return color;
  }
};
const responsiveStylesMixin = props => {
  if (!props.responsive) {
    return '';
  }
  return css(["@media (max-width:", "){padding:30px 36px;}@media (max-width:", "){padding:20px 24px;}"], GRID_BREAKPOINT_EXTRA_LARGE, GRID_BREAKPOINT_MEDIUM);
};
const MainSection = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest));
}).withConfig({
  displayName: "MainSection",
  componentId: "assjcw-0"
})(["padding:", "px ", "px;background-color:", ";", ""], MAIN_SECTION_PADDING_Y, MAIN_SECTION_PADDING_X, props => getBackgroundColor(props.color), responsiveStylesMixin);
MainSection.defaultProps = {
  color: 'default',
  responsive: false
};
export default MainSection;
export const DetailMainSection = styled(MainSection).withConfig({
  displayName: "MainSection__DetailMainSection",
  componentId: "assjcw-1"
})(["&&:last-child{margin-bottom:-", ";}"], LAYOUT_PADDING_X);